// Hardcoded reason/sub-reason configuration for escalation form
export const ESCALATION_REASONS = [
  {
    id: 'policy_blocker',
    label: 'Policy / Compliance Blocker',
    subreasons: [
      { id: 'requires_approval', label: 'Requires manager approval' },
      { id: 'policy_unclear', label: 'Policy unclear or missing' },
      { id: 'high_risk', label: 'High-risk exception' },
    ],
  },
  {
    id: 'platform_issue',
    label: 'Platform / Tooling Issue',
    subreasons: [
      { id: 'outage', label: 'Outage or degraded performance' },
      { id: 'bug', label: 'Product bug blocking completion' },
      { id: 'integration', label: 'Integration/service failing' },
    ],
  },
  {
    id: 'order_data',
    label: 'Order / Data Problem',
    subreasons: [
      { id: 'missing_data', label: 'Critical data missing' },
      { id: 'conflicting_data', label: 'Conflicting or incorrect data' },
      { id: 'customer_request', label: 'Customer special request needs approval' },
    ],
  },
  {
    id: 'vendor_issue',
    label: 'Vendor / Third-party Blocker',
    subreasons: [
      { id: 'store_blocked', label: 'Store account blocked/locked' },
      { id: 'payment_failure', label: 'Payment failure cannot resolve' },
      { id: 'driver_unavailable', label: 'No driver/fulfillment available' },
    ],
  },
  {
    id: 'other',
    label: 'Other (Describe)',
    subreasons: [
      { id: 'other_detail', label: 'Add context in notes' },
    ],
  },
];

export const ESCALATION_CHECKLIST = [
  'Reviewed knowledge base/playbook',
  'Attempted standard steps',
  'Contacted customer/merchant as needed',
  'Collected evidence/data for review',
];




